export const OptionAnswersOpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@option-answer-opinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@option-answer-opinometro/API_RESPONSE_ERROR',

  GET_OPTION_ANSWER_OPINOMETRO: '@@option-answer-opinometro/GET_OPTION_ANSWER_OPINOMETRO',
  LIST_OPTION_ANSWERS_OPINOMETRO: '@@option-answer-opinometro/LIST_OPTION_ANSWERS_OPINOMETRO',
  ADD_OPTION_ANSWER_OPINOMETRO: '@@option-answer-opinometro/ADD_OPTION_ANSWER_OPINOMETRO',
  UPDATE_OPTION_ANSWER_OPINOMETRO: '@@option-answer-opinometro/UPDATE_OPTION_ANSWER_OPINOMETRO',
  DELETE_OPTION_ANSWER_OPINOMETRO: '@@option-answer-opinometro/DELETE_OPTION_ANSWER_OPINOMETRO',

  RESET: '@@option-answer-opinometro/RESET'
}
